import { TabPanel } from '@mui/lab';
import Box from '@mui/material/Box';
import { Input } from '../../../../../shared/components/Input';
import { formatCurrency } from '../../../../../shared/utils/helpers/numbers';
import Divider from '@mui/material/Divider';
import DataTable from '../../../../../shared/components/Table';
import { GridColDef } from '@mui/x-data-grid';
import { formatDate } from '../../../../../shared/utils/helpers/date';
import { useEffect, useState } from 'react';
import { dup } from '../../../../../shared/types/nfe';

const COLUMNS: GridColDef[] = [
  {
    field: 'nDup',
    headerName: 'Número Documento',
    headerAlign: 'center',
    align: 'center',
    width: 200,
  },
  {
    field: 'dVenc',
    headerName: 'Vencimento',
    headerAlign: 'center',
    align: 'center',
    width: 200,
    valueGetter: (value) => formatDate(value),
  },
  {
    field: 'vDup',
    headerName: 'Valor',
    headerAlign: 'center',
    align: 'center',
    width: 200,
    valueGetter: (value) => formatCurrency(value, 2, 2)
  }
]

export const TabCobranca = ({ values } : { values: any }) => {
  const [fats, setFats] = useState<dup[]>([])

  const handleFats = (dup: dup[]): dup[] => {
    if (dup) {
      if (dup?.length) {
        return dup.map((item: dup, index: number) => {
          return {...item, id: index}
        })
      } else {
        // @ts-ignore - .
        return [{...dup, id: 1}]
      }
    }
    return []
  }

  useEffect(() => {
    setFats(handleFats(values?.nfeProc?.NFe?.infNFe?.cobr?.dup))
  }, [values?.nfeProc?.NFe?.infNFe?.cobr?.dup])



  return (
    <TabPanel value='7'>
      <Box className='grid grid-cols-8 gap-7 pt-4'>
        <Input
          disabled={true}
          label='Forma Pagamento'
          className='col-span-2'
          name='usu_nome'
          value={''}
        />
        <Input
          disabled={true}
          label='Número'
          className='col-span-2'
          name='usu_nome'
          value={values?.nfeProc?.NFe?.infNFe?.cobr?.fat?.nFat}
        />
        <Box className={'col-span-4'}/>
        <Input
          disabled={true}
          label='Valor Original'
          className='col-span-2'
          name='usu_nome'
          value={formatCurrency(values?.nfeProc?.NFe?.infNFe?.cobr?.fat?.vOrig, 2, 2)}
        />
        <Input
          disabled={true}
          label='Valor Desconto'
          className='col-span-2'
          name='usu_nome'
          value={formatCurrency(values?.nfeProc?.NFe?.infNFe?.cobr?.fat?.vDesc, 2, 2)}
        />
        <Input
          disabled={true}
          label='Valor Líquido'
          className='col-span-2'
          name='usu_nome'
          value={formatCurrency(values?.nfeProc?.NFe?.infNFe?.cobr?.fat?.vLiq, 2, 2)}
        />
        <Box className='col-span-4 py-4 pt-4'>
          <Divider className={'col-span-8'}/>
          <DataTable
            hideFooter={true}
            height={'30vh'}
            columns={COLUMNS}
            rows={fats}
            showFilter={false}
            showButtonToXlsx={false}
          />
        </Box>
      </Box>
    </TabPanel>
  )
}